import { Button } from '@mui/material'
import React from 'react'
import { useAppContext } from '../../contexts/AppContext'
import { useIsPortrait } from 'hooks/useIsPortrait';

interface PassportControlsProps {
  handleChooseAnotherFile: () => void
  handleConfirmFile: () => void
  uploadBtnLabel: string
  submitFileDisabled: boolean
}

const PassportControls: React.FC<PassportControlsProps> = ({
  handleChooseAnotherFile,
  handleConfirmFile,
  uploadBtnLabel,
  submitFileDisabled = true
}) => {
  const { isMobile } = useAppContext()
  const isPortrait = useIsPortrait()

  return (
    <div className='passport__buttons-container'>
      <div className='passport__button-group'>
        <Button
          variant='outlined'
          onClick={handleChooseAnotherFile}
          className={'passport__button'}
          style={{ width: isPortrait || !isMobile ? '46%' : '98%' }}
        >
          {uploadBtnLabel}
        </Button>
        <Button
          variant='contained'
          className={'passport__button'}
          disabled={submitFileDisabled}
          onClick={handleConfirmFile}
          style={{ width: isPortrait || !isMobile ? '46%' : '98%' }}
        >
          Submit File
        </Button>
      </div>
    </div>
  )
}

export default PassportControls
